import liveLocationIcon from "../../../../../../core/assets/live-location.png";
import ParkingModeIcon from "../../../../../../core/assets/parking-mode.png";
import EmergencyAlertsIcon from "../../../../../../core/assets/emergency-mode.png";
import RemoteStream from "../../../../../../core/assets/remote-stream.png";

export type Element = {
  title: string;
  description: string;
  icon: any;
};

export const elements: Element[] = [
  {
    title: "liveLocation",
    description: "trackTheCamerasLiveLocation",
    icon: liveLocationIcon,
  },
  {
    title: "parkingMode",
    description: "getAVideoIfSomethingHappens",
    icon: ParkingModeIcon,
  },
  {
    title: "emergencyAlerts",
    description: "emergencyContactsWillGet",
    icon: EmergencyAlertsIcon,
  },
  {
    title: "liveStrem",
    description: "remotelyConnectToTheDashCam",
    icon: RemoteStream,
  },
];
